<div class="page-layout simple fullwidth" fusePerfectScrollbar>
    <mat-tab-group>
        <mat-tab label="Upcoming Maintenance">
            <maintenance-list [maintenances]=maintenances [resolved]='false'></maintenance-list>
        </mat-tab>
        <mat-tab label="Maintenance Log">
            <maintenance-list [maintenances]=maintenances [resolved]='true'></maintenance-list>
        </mat-tab>
    </mat-tab-group>
</div>